import { useFirestoreLoaded } from '../../firebase/useFirestore'
import ActivityMeta from '../activities/ActivityMeta'
import MultiSelect from '../common/MultiSelect'
import useArrayLinkToggle from '../../hooks/useArrayLinkToggle'

/**
 * Link picker: which activities lead to this effect. Writes OutputEffects.Activity[]
 * (by activity ID, not docid).
 *
 * @param {object} props
 * @param {{docid: string, Activity?: string[]}} props.effect - The effect whose Activity[] link is edited.
 */
const SelectActivities = ({ effect }) => {
    const [activities, loaded] = useFirestoreLoaded('Activities')
    const toggleLink = useArrayLinkToggle()

    const selected = Array.isArray(effect.Activity) ? effect.Activity : []

    const toggle = (id, isSelected) => toggleLink({
        collection: 'OutputEffects',
        docid: effect.docid,
        field: 'Activity',
        value: id,
        isSelected,
    })

    const options = (activities || []).map(a => ({ id: a.ID, label: a.Activity }))

    return (
        <MultiSelect
            selected={selected}
            options={options}
            onToggle={toggle}
            loaded={loaded}
            renderSelected={(id) => <ActivityMeta id={id} inline={true} />}
            addLabel='+ Activiteit toevoegen'
            emptyLabel='Geen activiteit(en) toegevoegd'
            emptyOptionsLabel='Geen activiteiten beschikbaar'
            removeAriaLabel='Verwijder activiteit'
        />
    )
}

export default SelectActivities
